import { Alert } from "antd";
import { API_CHANGE_PASSWORD } from "../../utils/apis";
import { useEffect, useState } from "react";

export const usePasswordResetForm = ({ form }) => {
  const passwordsMatch = form?.password === form?.conf_password;
  const [passwordValid, setPasswordValid] = useState(false);
  const visible =
    form?.password != "" &&
    form?.password != null &&
    form?.conf_password != null &&
    form?.conf_password != "";

  const passwordValidate = (password: string) => {
    return (
      password.length >= 7 &&
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\W]{7,}$/.test(
        password,
      )
    );
  };

  useEffect(() => {
    if (form?.password) {
      const isValid = passwordValidate(form?.password);
      if (!isValid) {
        setPasswordValid(true);
      } else {
        setPasswordValid(false);
      }
    }
  }, [form?.password]);

  const fields: any = [
    {
      type: "component",
      component: (
        <p className="font13">
          Enter your new password here. It should have longer than{" "}
          <b>7 characters</b> and contain atleast an uppercase, lowercase,
          number, and special character.
        </p>
      ),
    },
    {
      field_name: "old_password",
      type: "text",
      label: "Old Password",
      props: { required: true, newLine: true, type: "password" },
    },
    {
      field_name: "password",
      type: "text",
      label: "New Password",
      props: { required: true, newLine: true, type: "password" },
    },
    {
      type: "component",
      visible: passwordValid,
      component: (
        <Alert
          showIcon
          message={
            "Password must be atleast 7 characters long \n Must contain atleast an uppercase, lowercase, number, and special character"
          }
          type="error"
        />
      ),
      props: { newLine: true },
    },
    {
      field_name: "conf_password",
      type: "text",
      label: "Confirm Password",
      props: { required: true, newLine: true, type: "password" },
    },

    {
      type: "component",
      visible,
      component: (
        <Alert
          showIcon
          message={
            passwordsMatch ? "Passwords Match" : "Passwords do not match"
          }
          type={passwordsMatch ? "success" : "error"}
        />
      ),
      props: { newLine: true },
    },
  ];
  const sections = [
    {
      title: "Change Password",
      fields,
    },
  ];

  return {
    sections,
    submitDisabled: !passwordsMatch || passwordValid,
  };
};

export function onPasswordResetFormSubmit(payload: any, id: number | null) {
  return {
    api: API_CHANGE_PASSWORD,
    id,
    params: {
      ...payload,
    },
  };
}
